import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { IPayment } from '@getgreenline/homi-shared'
import { ExpandablePaymentDetails } from '../../../../components/ExpandablePayment/ExpandablePaymentDetails'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  payment: IPayment
  currentEmployeeId: any
  canEditSales: boolean
  canEditCustomer: boolean
  canRefundSales: boolean
  onClose: () => void
  locationId: number | undefined
  hideButtons?: boolean
}

interface State {
  isSaving: boolean
  completed: boolean
  errorMessage?: string
  notes: string | undefined
}

@inject('currentCompanyStore')
@observer
export class PaymentDetailsModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
      completed: false,
      errorMessage: undefined,
      notes: undefined,
    }
  }

  render() {
    const {
      payment,
      currentEmployeeId,
      canEditSales,
      canRefundSales,
      canEditCustomer,
      locationId,
    } = this.props

    return (
      <Modal
        isOpen={true}
        toggle={() => this.props.onClose()}
        autoFocus={false}
        size='lg'
        closeOnClick={true}
      >
        <ModalHeader toggle={() => this.props.onClose()}>Payment Details</ModalHeader>
        <ModalBody>
          <ExpandablePaymentDetails
            payment={payment}
            canRefundSales={canRefundSales}
            canEditSales={canEditSales}
            canEditCustomer={canEditCustomer}
            locationId={locationId}
            currentEmployeeId={currentEmployeeId}
          />
        </ModalBody>
      </Modal>
    )
  }
}
